import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,CapaRow,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';
import SpeakersGrid from '../../components/SpeakersGrid';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Publicas from './modules/publicas';
import Programacao from '../Program';
import Vimeo from '../../components/Vimeo';
import GaleriaFotos from '../GaleriaFotos';
import ContagemRegressiva from '../../components/ContagemRegressiva';
import Logo from '../../components/Logo';
import Speakers from '../Speakers';
import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';
import Program from '../../components/Program';
import Youtube from '../../components/Youtube';
import { Sponsor, SponsorGrid } from '../Footer/styles';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

export const sponsors = [
  { image : '/assets/evento/logo.png', url: '', size: 'normal'},
  { image : '/assets/evento/ufrgs.png', url: '', size: 'normal'},


]

export const products = [
  { title : 'Estudantes de graduação', prices: [{ label :'Após 13/10', value: 'R$ 50,00'} ]},
  { title : 'Funcionários do HCPA, sócios da SBP e Abramed e residentes', prices: [{ label :'Após 13/10', value: 'R$ 80,00'} ]},
  { title : 'Demais profissionais', prices: [ { label :'Após 13/10', value: 'R$ 100,00'} ]},
]

const SignIn: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { addModal, removeModal } = useModal();
  const formRef = useRef<FormHandles>(null);
  const [cardLayout, setCardLayout] = useState([] as Array<JSX.Element>);
  const { readPages } = usePages();

  const [pages, setPages] = useState(readPages());

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Email obrigatório')
            .email('Preencha um email válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, { abortEarly: false });

        const { email, password } = data;

        await signIn({ email, password });
        history.push('/dashboard');
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, history],
  );

  const buildCard: React.FC<IPublicData> = ({ icon, title, text }) => {
    return (
      <div
        onClick={() =>
          setCardLayout([<Publicas icon={icon} text={text} title={title} />])}
      >
        {icon({})}
        <p>{title}</p>
      </div>
    );
  };

  return (
    <>
      <Capa>
        <CapaRow>
      <div className="alignDiv">
          <img className="tedBear" src="/assets/evento/urso.png"/>
        </div>
        <div className="p50">
  
            <img style={{width:'100%'}} src="/assets/evento/capa/nome.png"/>
            <img style={{width:'100%', marginTop:"7%"}} src="/assets/evento/data.png"/>

            <CapaRow style={{justifyContent:'flex-end', alignItems: 'center', padding:"20px 0px 0px 0px"}}>
        <SponsorGrid>
{sponsors.map( apoio => <Sponsor background={apoio.image} key={apoio.image} />)}

  </SponsorGrid></CapaRow>

       

        </div></CapaRow>
  
  <CapaRow style={{minHeight: 'auto', justifyContent:'center', flexDirection: 'row' }}>  <a style={{margin:'5px'}}
            href="https://fundacaomedica2.hcpa.ufrgs.br/eventos/listarevento.aspx?54321"
            target="_BLANK"
          >
            {' '}
            <Button  type="button">
              Inscreva-se!
            </Button>
            
          </a>
          <Link style={{margin:'5px'}}
            to="/login"
         
          >
            {' '}
            <Button  type="button">
              Acessar
            </Button>
            
          </Link>
    </CapaRow></Capa>
    <ContainerWhite  background="rgb(50,70,107)"> 
<div className="p50 p600 colorWhite">
<h2>Vamos fazer juntos um baita evento!</h2>
<p>A Jornada Latino-Americana de Emergências Pediátricas foi concebida e tem sido programada pensando nos participantes, nos assuntos mais relevantes e nas melhores oportunidades de debate. 
Vamos viver juntos a primeira experiência desse evento no formato digital e queremos que essa seja uma oportunidade para agregarmos conhecimentos e somarmos boas práticas.
</p>
<br/>
<strong>Os temas principais serão:</strong>
<ul>
<li> Asma aguda grave</li>
<li> Oxigenoterapia de alto fluxo</li>
<li> Emergência na pandemia - Covid-19</li>
<li> Sepse - Sempre temos o que aprender</li>
<li> Febre ainda dá susto</li>
<li> Novas perspectivas na imunização</li>
</ul>
<div style={{marginTop:'20px'}}>
<strong >Visita virtual à nova Emergência Pediátrica do HCPA</strong>
<br/><br/>
<a href={`https://api.whatsapp.com/send?text=${encodeURI("III Jornada Latino-americana de Emergências Pediátricas do Hospital de Clínicas de Porto Alegre - https://jornada-emergencias-pediatricas.encontrodigital.com.br/")}`} target="_BLANK"><p style={{ padding: '10px', border: '1px solid #fff', color: '#fff', textAlign:"center", cursor:'pointer'}}>Participe e compartilhe o evento com seus colegas, divulgue!</p></a></div>
</div>
</ContainerWhite>

<ContainerWhite style={{justifyContent: 'flex-start', alignItems: 'flex-start'}} id="programacao"> 
<Program/>

</ContainerWhite>
<Speakers/>       

      <ContainerWhite id="inscricao" background="none"> 
<div style={{textAlign:'center'}}>
<h2 style={{textAlign:'center', marginTop:'30px'}}> INVESTIMENTO</h2>  

<div className="priceGrid">
{products.map(product => (

<a href="https://fundacaomedica2.hcpa.ufrgs.br/eventos/listarevento.aspx?54321" target="_BLANK">
<div key={product.title}>
<strong>{product.title}</strong>
{product.prices && product.prices.map( prices => 
  <nav key={`${product.title}-${prices.value}`}><span>{prices.label}</span>  <span style={{fontWeight:"bold"}}>{prices.value}</span>    </nav>
  
  )}

</div></a>

))}



</div>


  <strong style={{textAlign:'center', margin: 'auto'}}>Parte do lucro do evento será revertido em doações para a Emergência Pediátrica do HCPA.</strong>
  </div>

  </ContainerWhite> 


    </>
  );
};
export default SignIn;
